/* FAQ accordion. Reproduces the reference behaviour exactly:
   - JS height animation (element.style.height = scrollHeight + 'px'),
     eased by the CSS `transition: all 0.3s ease` on the panel.
   - Chevron rotation has no CSS transition, so it snaps instantly.
   - Only one item open at a time; opening one closes the others.
   - All items start closed. */

(function () {
  var faqSections = document.querySelectorAll('.up-faq');

  faqSections.forEach(function (section) {
    var items = section.querySelectorAll('.up-faq__item');

    function closeItem(item) {
      var toggle = item.querySelector('.up-faq__toggle');
      var panel = item.querySelector('.up-faq__panel');
      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.style.height = '0px';
    }

    function openItem(item) {
      var toggle = item.querySelector('.up-faq__toggle');
      var panel = item.querySelector('.up-faq__panel');
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.style.height = panel.scrollHeight + 'px';
    }

    items.forEach(function (item) {
      var toggle = item.querySelector('.up-faq__toggle');

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (other) {
          if (other !== item) {
            closeItem(other);
          }
        });

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  });
})();
